import PageLayout from "@/pages/home/components/PageLayout";
import HowToBookSection from "@/pages/home/components/HowToBookSection";

export default function HowToBookPage() {
  return (
    <PageLayout>
      <HowToBookSection />
    </PageLayout>
  );
}
